import LocationAlarmsRoutes from './LocationAlarmsRoutes';

export function LocationAlarmsRoot() {
  return <LocationAlarmsRoutes />;
}

export default LocationAlarmsRoot;
